module.exports = __webpack_public_path__ + "static/media/docusign-logo.a3d5a58f.png";